import { render, staticRenderFns } from "./CollapseProject.vue?vue&type=template&id=3b746109&scoped=true&"
import script from "./CollapseProject.vue?vue&type=script&lang=js&"
export * from "./CollapseProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b746109",
  null
  
)

export default component.exports